"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidersEnum = void 0;
var ProvidersEnum;
(function (ProvidersEnum) {
    ProvidersEnum["PRAGMATIC"] = "pragmatic play";
    ProvidersEnum["EVOLUTION"] = "evolution";
    ProvidersEnum["NETENT"] = "net-ent";
    ProvidersEnum["PGSOFT"] = "PG Soft";
    ProvidersEnum["EVOPLAY"] = "Evoplay";
    ProvidersEnum["SPRIBE"] = "Spribe";
})(ProvidersEnum || (exports.ProvidersEnum = ProvidersEnum = {}));
//# sourceMappingURL=casinoProviders.js.map